import { useWs } from "@shared/transport/useWs";

import type { DevicePrekey } from "shared";

const TIMEOUT_MS = 5000;

// Запросы в полёте (модульный уровень — общий для всех инстансов): параллельные
// fetchPrekeys на один ключ сливаются в один get_prekeys. Важно для «Избранного»
// (to === from → buildBundle иначе шлёт два одинаковых запроса на каждое
// сообщение). Кэша по времени нет намеренно: prekey эпохальные, берём свежие.
const inflight = new Map<string, Promise<DevicePrekey[]>>();

// Запрашивает эпохальные prekey всех устройств аккаунта (get_prekeys) и ждёт
// ответ prekeys. Отправитель шифрует сообщение под каждый.
export function usePrekeys() {
    const { send, subscribe } = useWs();

    function fetchPrekeys(signPubKey: string): Promise<DevicePrekey[]> {
        const existing = inflight.get(signPubKey);
        if (existing) {
            return existing;
        }
        const promise = new Promise<DevicePrekey[]>((resolve) => {
            let done = false;
            const finish = (devices: DevicePrekey[]) => {
                if (done) {
                    return;
                }
                done = true;
                unsub();
                inflight.delete(signPubKey);
                resolve(devices);
            };
            const unsub = subscribe("prekeys", (msg) => {
                if (msg.payload.signPubKey === signPubKey) {
                    finish(msg.payload.devices);
                }
            });
            send({ type: "get_prekeys", payload: { signPubKey } });
            // Нет ответа за таймаут — пустой список (никому не отправим).
            setTimeout(() => finish([]), TIMEOUT_MS);
        });
        inflight.set(signPubKey, promise);
        return promise;
    }

    return { fetchPrekeys };
}
